/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["tengah malam", "tengah hari", "pagi", "siang", "sore", "malam"], u, u], u, ["00:00", "12:00", ["00:00", "10:00"], ["10:00", "15:00"], ["15:00", "18:00"], ["18:00", "24:00"]]];
